<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <div class="text-right">
          <b-button
            variant="primary"
            :to="$route.path + '/prices/add'"
          >
            <FeatherIcon icon="PlusIcon" /> Oluştur
          </b-button>
        </div>
      </b-card-body>
      <b-table
        responsive="sm"
        :fields="fields"
        :items="dataList"
        striped
        :busy="loading"
        :empty-text="emptyText"
        :show-empty="!!emptyText"
        bordered
        class="mb-0"
        small
      >
        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle" />
            <strong class="ml-2">Yükleniyor...</strong>
          </div>
        </template>
        <template #head(unit_sale)>
          TAVSİYE EDİLEN<br>BİRİM SATIŞ FİYATI
        </template>
        <template #cell(unit)="data">
          {{ data.item.quantity | toNumber }} {{ data.item.unit }}
        </template>
        <template #cell(unit_cost)="data">
          {{ data.item.unit_cost | toNumber }} {{ data.item.currency }}
          <div class="font-small-2 text-muted">
            (KDV Hariç)
          </div>
        </template>
        <template #cell(unit_sale)="data">
          {{ data.item.unit_sale | toNumber }} {{ data.item.currency }}
          <div class="font-small-2 text-muted">
            (KDV Hariç)
          </div>
        </template>
        <template #cell(tax)="data">
          {{ data.item.tax }}
        </template>
        <template #cell(control)="data">
          <div class="text-left">
            <list-buttons
              :edit-action="$route.path + '/prices/edit/' + data.item.id"
              :delete-action="removeData"
              :data-id="data.item.id"
            />
          </div>
          <div class="font-small-3 text-primary font-weight-bold mt-1">
            {{ data.item.username }}
          </div>
          <div class="text-primary font-small-3">
            <FeatherIcon
              icon="SaveIcon"
            />
            {{ moment(data.item.modified).format('DD.MM.YYYY') }}
          </div>
        </template>
      </b-table>
      <b-card-footer>
        <b-pagination
          v-if="dataCounts > perPage"
          v-model="currentPage"
          :total-rows="dataCounts"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination>
      </b-card-footer>
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BCardBody, BTable, BPagination, BButton, BCardFooter, BSpinner,
} from 'bootstrap-vue'
import ListButtons from '@/layouts/components/common/ListButtons.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const tableName = 'product_prices'
export default {
  name: 'ProductsPricesCard',
  components: {
    BCard,
    BCardBody,
    BTable,
    BPagination,
    BButton,
    BCardFooter,
    ListButtons,
    BSpinner,
  },
  data() {
    return {
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'unit',
          label: 'BİRİM',
          thClass: 'width-100 text-center text-nowrap align-middle',
          tdClass: 'width-100 text-center text-nowrap align-middle',
          thStyle: { width: '150px !important' },
        },
        {
          key: 'unit_cost',
          label: 'BİRİM MALİYET',
          thClass: 'text-center text-nowrap align-middle',
          tdClass: 'text-center text-nowrap align-middle',
          thStyle: { width: '150px !important' },
        },
        {
          key: 'unit_sale',
          label: 'TAVSİYE EDİLEN BİRİM SATIŞ FİYATI',
          thClass: 'text-center text-nowrap align-middle',
          tdClass: 'text-center text-nowrap align-middle',
          thStyle: { width: '150px !important' },
        },
        {
          key: 'tax',
          label: 'KDV Oranı',
          thClass: 'text-center text-nowrap align-middle',
          tdClass: 'text-center text-nowrap align-middle',
          thStyle: { width: '150px !important' },
        },
        {
          key: 'notes',
          label: 'Notlar',
          thClass: 'width-auto text-left align-middle',
          tdClass: 'width-auto text-left align-middle',
        },
        {
          key: 'control',
          label: 'GÜNCELLEME',
          thClass: 'text-nowrap text-left align-middle',
          tdClass: 'text-nowrap text-left align-middle',
          thStyle: { width: '160px !important' },
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          'units.title As unit',
          `${tableName}.quantity AS quantity`,
          `${tableName}.unit_cost AS unit_cost`,
          `${tableName}.unit_sale AS unit_sale`,
          `${tableName}.notes AS notes`,
          `${tableName}.modified AS modified`,
          'currencies.str_value_2 AS currency',
          'taxes.title AS tax',
          'users.name AS username',
        ],
        where: {
          'product_prices.id_products': this.$route.params.id,
        },
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    loading() {
      return this.$store.getters['productPrices/loading']
    },
    emptyText() {
      if (this.loading === true) {
        return 'Lütfen bekleyiniz...'
      }
      if (this.dataList.length === 0) {
        return 'İçerik bulunamadı.'
      }
      return null
    },
    dataList() {
      return this.$store.getters['productPrices/dataList']
    },
    dataCounts() {
      return this.$store.getters['productPrices/dataCounts']
    },
    product() {
      return this.$store.getters['products/dataItem']
    },
    saveData() {
      return this.$store.getters['productPrices/dataSaveStatus']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
      this.getDataList()
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('productPrices/getDataList', this.dataQuery)
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('productPrices/removeData', id)
          this.$swal({
            icon: 'success',
            title: this.$store.state.app.removeResultTitle,
            text: this.$store.state.app.removeResultMessage,
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
